module.exports = __webpack_public_path__ + "static/media/vin_info.1714f3dc.svg";